const berrysServiceOpeners = new WeakMap();
document.addEventListener('click', function(event) {
  const item = event.target.closest('.bj-product-icon-with-text-item[data-id], [data-service-drawer]');
  if (item) {
    const drawer = document.getElementById(item.getAttribute('aria-controls'));
    if (!drawer || !drawer.matches('dialog.berrys-service-drawer')) return;
    const current = item.closest('dialog.berrys-service-drawer');
    const opener = current ? berrysServiceOpeners.get(current) : item;
    if (current) current.close();
    berrysServiceOpeners.set(drawer, opener);
    drawer.showModal();
    drawer.querySelector('.berrys-service-drawer__body').scrollTop = 0;
    return;
  }
  const close = event.target.closest('.berrys-service-drawer__close');
  if (close) {
    close.closest('dialog').close();
    return;
  }
  const drawer = event.target;
  if (drawer.matches('dialog.berrys-service-drawer[open]')) {
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) drawer.close();
  }
});
document.addEventListener('close', function(event) {
  const drawer = event.target;
  if (!drawer.matches('dialog.berrys-service-drawer')) return;
  const opener = berrysServiceOpeners.get(drawer);
  if (!document.querySelector('dialog.berrys-service-drawer[open]') && opener && opener.isConnected) opener.focus({preventScroll: true});
}, true);
